/* angular:styles/component:css;0265d3ea786b7a2b49562ce51a4b71b9a01e4ac27922e7dced5378197830f967;/Users/stevennaimark/devtoil/Ziptility/Bivvy/src/app/notifications/notification.component.ts */
.notification {
  font-size: 15px;
  color: #0c1f30;
  position: relative;
  margin-bottom: 12px;
}
.date {
  font-size: 13px;
  color: #9da6ac;
  margin-top: 2px;
  opacity: 0.9;
  font-weight: 500;
  line-height: 1.33;
  letter-spacing: -0.2px;
  color: #a3a7aa;
}
/*# sourceMappingURL=notification.component.css.map */
